import {useEffect, useState} from "react";
import ToiletReviewService from "../../services/reviews/ToiletReviewService";
import {getRandomColor} from "../../utils/GetRandomColor";

export default function GameReviewTable() {
    const [reviews, setReviews] = useState([]);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await ToiletReviewService.getAllReviews();
                const sortedData = data.sort((b, a) => b.overallRating - a.overallRating);
                setReviews(sortedData);
            } catch (error) {
                console.error("Failed to fetch reviews:", error);
            }
        };

        fetchReviews();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsNarrowScreen(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const bannerImageStyle = {
        width: "100%",
        minHeight: isNarrowScreen ? '500px' : '275px',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '10px',
        marginBottom: '20px',
        position: 'relative',
    };

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 1,
    };

    const contentStyle = {
        position: 'relative',
        zIndex: 2,
    };

    const overallRatingStyle = {
        fontSize: '96px',
        fontWeight: 'bold',
    };

    const gameNameStyle = {
        marginTop: '10px',
        marginBottom: 0,
    };

    const metricsStyle = {
        textAlign: 'right',
    };

    return (
        <div>
            {reviews.map((review) => (
                <div key={review.id}>
                    <div style={{...bannerImageStyle, backgroundImage: `url(${review.imgLink})`, outline: getRandomColor() + ' solid 5px',}}>
                        <div style={overlayStyle}></div>
                        <div style={contentStyle} className="row">
                            <div className="col-md-6">
                                <h1 style={gameNameStyle}>{review.toiletName}</h1>
                                <p style={overallRatingStyle}>{review.overallRating}</p>
                            </div>

                            <div className="col-md-6" style={metricsStyle}>
                                <p>Hygiene: {review.cleanliness}</p>
                                <p>Toilet Paper: {review.toiletPaper}</p>
                                <p>Smell: {review.smell}</p>
                                <p>Bidet Nozzle: {review.bidetNozzle}</p>
                                <p>Soap: {review.soap}</p>
                                <p>Comfort: {review.comfort}</p>
                                <p>Lighting: {review.lighting}</p>
                                <p>Airiness: {review.airiness}</p>
                                <p>Door Lock: {review.doorLock}</p>
                                <p>Flush: {review.flush}</p>
                            </div>
                        </div>

                    </div>
                </div>
            ))}
        </div>
    );
}